export default [
  /*** 机构-推广商品 ***/
  {
    path: '/warrant/productMange',
    component: () => import('../pages/warrant/productMange/index.vue'),
    meta: { title: '推广商品' }
  },
  {
    path: '/warrant/orderMange',
    component: () => import('../pages/warrant/orderMange/index.vue'),
    meta: { title: '订单管理' }
  },
  {
    path: '/warrant/writeoffMange',
    component: () => import('../pages/warrant/writeoffMange/index.vue'),
    meta: { title: '核销管理' }
  },
]
